import { check2FA } from "src/requests/loader"
import timerManager, { MINUTES_TO_HELP, SECONDS_FOR_RECURRENT_CALL, TimerType, DataToShowTicket } from "./TimerManager"
import { AAFPLAYER_PLAY } from "src/AAFPlayer/constants"
import store from "src/store"
import { MODAL_2FA_EXPIRED_CODE, MODAL_HELP_2FA, MODAL_ONLINE_DEBT, showModal } from "src/actions/modal"
import { showLimiteCompras, showRecuerdaConfirmarCompra } from "src/payments/utils/Utils"
import AAFPlayer from "src/AAFPlayer/AAFPlayer"
import DeviceStorage from "src/components/DeviceStorage/DeviceStorage"

const statusCheck2FA = {
    PENDING: 'PENDING',
    PGS_CHK_00001: 'PGS_CHK_00001',
    PGS_G3_00702: 'PGS_G3_00702',
    PGS_G3_00779: '0PGS_G3_00779',
    PGS_G3_00700: 'PGS_G3_00700',
    PGS_G3_00701: 'PGS_G3_00701',
    PGS_G3_00385: 'PGS_G3_00385',
    PGS_G3_00384: 'PGS_G3_00384',
    PGS_G3_00251: 'PGS_G3_00251',
    PGS_G3_00250: 'PGS_G3_00250'
} 

type WorkflowStart = {
    contentInfo: {
        contentTitle: string;
        
    };
    list: [
        {
            gateway: string;
            producttype: string;
        }
    ];
};

export const secondsForRecurrentCallCallback = async (idTransaction: string, timerId: TimerType, check2faURL: string, dataBuyconfirm: any, dataToShowTicket: DataToShowTicket, paramsMetrics2FA: any) => {
    try{
        const check2FAResponse  = await check2FA({transactionId: idTransaction, check2faURL})
        
        const { status } =  check2FAResponse.data as { status: keyof typeof statusCheck2FA };
        
        if (status && statusCheck2FA[status] === 'PENDING') {
            timerManager.resetTimer(idTransaction, SECONDS_FOR_RECURRENT_CALL)
            return
        }

        const { purchase_data, paymentMethodData} = check2FAResponse.data
        if(purchase_data && paymentMethodData){
            timerManager.deleteTransaction(idTransaction)
            // mandar modal del ticket de compra
            const showTicketFrom2FATelmex = dataToShowTicket.showTicket;
            pausePlayer()
            showTicketFrom2FATelmex(check2FAResponse, dataToShowTicket.groupId, dataToShowTicket.islive, true, paramsMetrics2FA);
            return
        }
    }catch (error) {
        const { code } = error as { code: keyof typeof statusCheck2FA };
        
        if(code && statusCheck2FA[code] === 'PGS_CHK_00001') {
            timerManager.resetTimer(idTransaction, SECONDS_FOR_RECURRENT_CALL)
            return
        }
        
        // Que hacer con los temporizadores, se mantienen a pesar de recibir estos errores con status de 400?
        if(code && (statusCheck2FA[code] === 'PGS_G3_00702' || statusCheck2FA[code] === '0PGS_G3_00779')){
            timerManager.deleteTransaction(idTransaction)
            pausePlayer()
            showLimiteCompras()
            return
        }

        if(code && (statusCheck2FA[code] === 'PGS_G3_00700' || statusCheck2FA[code] === 'PGS_G3_00701' || statusCheck2FA[code] === 'PGS_G3_00385')){
            const modal = {
                modalType: MODAL_ONLINE_DEBT,
                modalProps: {
                    callbackWhenBack: () => {
                        resumePlayer()
                    },
                    dataMetrics2FA: paramsMetrics2FA
                }
            }
            store.dispatch(showModal(modal))
            pausePlayer()
            return
        }

        if(code && (statusCheck2FA[code] === 'PGS_G3_00384' || statusCheck2FA[code] === 'PGS_G3_00251' || statusCheck2FA[code] === 'PGS_G3_00250')){
            const modal = {
                modalType: MODAL_HELP_2FA,
                modalProps: {
                    callbackWhenBack: () => {
                        timerManager.deleteTransaction(idTransaction)
                        resumePlayer()
                    },
                    dataMetrics2FA: paramsMetrics2FA
                }
            }
            store.dispatch(showModal(modal))
            pausePlayer()
            return
        }
    }
 
}

export const minutesToRequestResendCallback = async (idTransaction: string, timerId: TimerType, check2faURL: string, dataBuyconfirm: any, dataToShowTicket: any, paramsMetrics2FA: any) => {
    try{
        const check2FAResponse  = await check2FA({transactionId: idTransaction, check2faURL})
        
        const { status } =  check2FAResponse.data as { status: keyof typeof statusCheck2FA };
        
        if (status && statusCheck2FA[status] !== 'PENDING') return
        
        timerManager.createTimer(idTransaction, MINUTES_TO_HELP)
        if (DeviceStorage.getItem('count_2FA') < DeviceStorage.getItem('max_num_resend_2FA')){
            showRecuerdaConfirmarCompra(paramsMetrics2FA);
        }else{
            const modal = {
                modalType: MODAL_HELP_2FA,
                modalProps: {
                    callbackWhenBack: () => {
                        timerManager.deleteTransaction(idTransaction)
                        resumePlayer()
                    },
                    dataMetrics2FA: paramsMetrics2FA
                }
            }
            store.dispatch(showModal(modal))
            pausePlayer()
        }
    }catch (error) {
        throw(error)
    }
}

export const minutesToExpireLinkCallback = async (
    idTransaction: string,
    timerId: TimerType,
    check2faURL: string,
    dataBuyconfirm: any,
    dataToShowTicket: DataToShowTicket,
    paramsMetrics2FA: any
) => {
    const worflowstart = dataToShowTicket.worflowstart as WorkflowStart;
    // Respuesta de la /workflowstart cuando es un VOD.
    const titleVOD = worflowstart && worflowstart.contentInfo && worflowstart.contentInfo.contentTitle;
    // Respuesta de la /workflowstart cuando es un Add - On.
    const arrayListWorkflowstart = worflowstart && worflowstart.list;
    const item = arrayListWorkflowstart.find(findGateway => findGateway.gateway === "telmexmexicogate");
    const producttype = item && item.producttype;

    // mandar modal de Tu código de compra ha expirado
    const modal = {
        modalType: MODAL_2FA_EXPIRED_CODE,
        modalProps: {
            dataBuyconfirm,
            dataToShowTicket,
            titleVOD,
            producttype,
            transactionId: idTransaction,
            dataMetrics2FA: paramsMetrics2FA,
            callbackWhenBack: () => {
                timerManager.deleteTransaction(idTransaction)
                resumePlayer()
            }
        }
    };
    store.dispatch(showModal(modal))   

    timerManager.createTimer(idTransaction, MINUTES_TO_HELP)
    pausePlayer()
}

export const minutesToHelpCallback = async (idTransaction: string, timerId: TimerType, check2faURL: string, dataBuyconfirm: any, dataToShowTicket: any, paramsMetrics2FA: any) => {
    const modal = {
        modalType: MODAL_HELP_2FA,
        modalProps: {
            callbackWhenBack: () => {
                timerManager.deleteTransaction(idTransaction)
                resumePlayer()
            },
            dataMetrics2FA: paramsMetrics2FA
        }
    }

    store.dispatch(showModal(modal))
    pausePlayer()
}


export const pausePlayer = () => {
    try{
         const playerState = AAFPlayer.getCurrentPlayingState(false)
        if (playerState === AAFPLAYER_PLAY) AAFPlayer.pause()
    }catch(e){
        console.log('error al pausar', e)
    }
   
}

export const resumePlayer = () => {
    try{
        const playerState = AAFPlayer.getCurrentPlayingState(false)
        if (playerState === AAFPLAYER_PLAY) AAFPlayer.play()
    }catch(e){
        console.log('error al reanudar', e)   
    }
}


// WEBPACK FOOTER //
// ./src/2FA/callbacks.ts